import { i18n } from 'fishx';

import { getFormErrorI18n } from '@/utils';

export const getExchangeOfferFormItems = ({ exchangeCodeList, stdCodeList, handleExchangeChange, handleStdCodeChange, exchangeId, stdCode, disabled }) => ([
  {
    label: i18n('FIBER_EXCHANGE'),
    name: 'BSNL_FTTH_EXCH',
    options: {
      initialValue: exchangeId,
      rules: [{ required: true, message: getFormErrorI18n(i18n('FIBER_EXCHANGE')) }],
    },
    type: 'select',
    renderField: {
      valueField: 'exchangeId',
      lableField: 'exchangeCode',
    },
    data: exchangeCodeList,
    formItemCompProps: {
      disabled: disabled,
      placeholder: i18n('PLEASE_SELECT'),
      onChange: handleExchangeChange,
    },
  },
  {
    label: i18n('FIBER_STD_CODE'),
    name: 'BSNL_FTTH_STD',
    options: {
      initialValue: stdCode,
      rules: [{ required: true, message: getFormErrorI18n(i18n('FIBER_STD_CODE')) }],
    },
    type: 'select',
    data: stdCodeList,
    renderField: {
      valueField: 'stdCode',
      lableField: 'stdCode',
    },
    formItemCompProps: {
      disabled: disabled,
      placeholder: i18n('PLEASE_SELECT'),
      onChange: handleStdCodeChange,
    },
  }
]);
